export enum ISportClubNotificationType {
  court_reservation = "court_reservation",
  challenge = "challenge",
  ANNOUNCMENTS = "ANNOUNCMENTS",
}

export enum ISportClubNotificationEvent {
  ANNOUNCMENT_CREATED = "ANNOUNCMENT_CREATED",
  created = "created",
  reserved = "reserved",
  canceled = "canceled",
}
